import { api, apiMipe } from '@/core/api/';
import academicYearService from '@/modules/common/academicyear.api';

const apiUrl = 'api/providerregistryvisit';
export default {
  async getAcademicYears() {
    return academicYearService.getRegistryVisit();
  },
  async getPreviousYearAndCompensatoryIdsForRegisterVisit(
    studentSieId,
    disciplineTypeId
  ) {
    return await api.get(
      `api/compensatoryrequest/yearsandcompensatoriesforvisitregistry/${studentSieId}/${disciplineTypeId}`
    );
  },
  async getEducationalCompensatoryServiceBalance(studentSieId, statusId) {
    return await apiMipe.get(
      `/api/pei/educationalcompensatoryservicebalance/${studentSieId}`,
      {
        params: {
          statusId,
          excludeRejectedAndIncomplete: true,
        },
      }
    );
  },
  async getMonths(academicYear) {
    let { data } = await api
      .get(`${apiUrl}/months/${academicYear.id}`)
      .catch(() => {
        return [];
      });

    const mappedMonths = data.map((item) => {
      return {
        id: item.monthDesc,
        selected: false,
        disabled: false,
        isDirty: false,
        name: item.monthDesc,
        sortOrder: 0,
        monthNumber: item.monthNumber,
        year: item.year,
      };
    });

    return {
      months: data,
      mappedMonths,
    };
  },
  async getSpecialists(
    { academicYearId, month } = {},
    { companyId, disciplineTypeId } = {}
  ) {
    try {
      const { data } = await api.get(
        `${apiUrl}/specialists/${academicYearId}/${month}`,
        {
          params: {
            companyId,
            disciplineTypeId,
          },
        }
      );
      if (data) {
        return data;
      }
    } catch {
      return [];
    }
  },
  async getCompanies(params) {
    try {
      const { data } = await api.get(
        `${apiUrl}/companies/${params.academicYearId}/${params.month}`
      );
      if (data) {
        return data;
      }
    } catch (e) {
      return [];
    }
  },
  //Advanced Filters
  async getServices(params) {
    try {
      const { data } = await api.get(`${apiUrl}/services/${params.month}`, {
        params: {
          specialistId: params.specialistId,
          companyId: params.companyId,
        },
      });
      if (data) {
        return data;
      }
    } catch (e) {
      return [];
    }
  },
  async getCenters(params) {
    try {
      const { data } = await api.get(
        `${apiUrl}/centers/${params.academicYearId}/${params.month}`,
        {
          params: {
            specialistId: params.specialistId,
            companyId: params.companyId,
          },
        }
      );
      if (data) {
        return data;
      }
    } catch (e) {
      return [];
    }
  },
  async getLocationsType() {
    try {
      const { data } = await api.get(`${apiUrl}/locationsType`);
      if (data) {
        return data;
      }
    } catch (e) {
      return [];
    }
  },
  async getLocations(params) {
    try {
      const { data } = await api.get(`${apiUrl}/locations/${params.month}`, {
        params: {
          specialistId: params.specialistId,
          companyId: params.companyId,
          locationTypeId: params.locationTypeId,
        },
      });
      if (data) {
        return data;
      }
    } catch (e) {
      return [];
    }
  },
  async search(payload) {
    try {
      const { data } = await api.get(`${apiUrl}/search/`, {
        params: payload,
      });
      if (data) {
        return data;
      }
    } catch {
      return [];
    }
  },
  async searchDetails(id, serviceDate, isEducativeService) {
    try {
      const { data } = await api.get(`${apiUrl}/search/visitdetails`, {
        params: {
          id,
          serviceDate: serviceDate,
          isEducativeService: isEducativeService,
        },
      });
      if (data) {
        return data;
      }
    } catch {
      return [];
    }
  },
  async getInterventionPlan(studentServiceId) {
    return await api.get(`${apiUrl}/intervationsplan/${studentServiceId}`);
  },
  async getVistTypes(
    requestTypeId = null,
    disciplineTypeId = null,
    academicYearId = null,
    visitDate = null,
    schoolTypeId = null
  ) {
    return await api.get(`${apiUrl}/visittypes`, {
      params: {
        requestTypeId,
        disciplineTypeId,
        academicYearId,
        visitDate,
        schoolTypeId,
      },
    });
  },
  async getDocumentTypes() {
    return await api.get(`${apiUrl}/documentstype`);
  },
  async getVisitAbsenceRegistration() {
    return await api.get(`${apiUrl}/visitabsenceregistration`);
  },
  //OBSOLETE: this metho need a revision becouse the tables used to reach the practitioners are deprecated ones.
  async getPractitioner(studentServiceId, visitDate) {
    return await api.get(`${apiUrl}/practitioner`, {
      params: {
        studentServiceId,
        visitDate,
      },
    });
  },
  async getPractitionerFromSpecialistId(
    specialistId,
    disciplineTypeId,
    visitDate
  ) {
    return await api.get(`${apiUrl}/practitionerfromspecialistId`, {
      params: {
        specialistId,
        disciplineTypeId,
        visitDate,
      },
    });
  },
  async saveVisit(data) {
    return api.post(`${apiUrl}/visit`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  async saveEditVisit(data) {
    return api.put(`${apiUrl}/visit`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  async deleteVisit(id) {
    return await api.get(`${apiUrl}/delete/${id}`);
  },
  async getVisitValidReplacement(academicYearId, studentServiceId) {
    return await api.get(
      `${apiUrl}/visitvalidreplacement/${academicYearId}/${studentServiceId}`
    );
  },
  async getVisitValidReposition(academicYearId, studentServiceId) {
    return await api.get(
      `${apiUrl}/visitvalidreposition/${academicYearId}/${studentServiceId}`
    );
  },
  async haveReplacementVisit(id) {
    return await api.get(`${apiUrl}/havereplacementvisit/${id}`);
  },
  async isFinalizedPeriod(
    academicYearId,
    month,
    specialistId,
    companyId,
    centerId
  ) {
    return await api.get(`${apiUrl}/isfinalized`, {
      params: {
        academicYearId,
        month,
        specialistId,
        companyId,
        centerId,
      },
    });
  },
  async visitValidationInfo(
    studentServiceId,
    academicYearId,
    monthDate,
    centerId
  ) {
    return await api.get(`${apiUrl}/visitvalidationinfo`, {
      params: {
        studentServiceId,
        academicYearId,
        monthDate,
        centerId,
      },
    });
  },
  async getVisits(
    studentServiceIds,
    month,
    periodAcademicYear,
    compensatoryRequestType = null,
    companyId
  ) {
    return await api.get(`${apiUrl}/visits/`, {
      params: {
        studentServiceIds: studentServiceIds,
        month: month,
        periodAcademicYear,
        compensatoryRequestType,
        companyId,
      },
    });
  },
  async getSpecialistReplacement(
    academicYearId,
    disciplineId,
    companyId,
    admissionId,
    visitDate
  ) {
    return await api.get(
      `${apiUrl}/specialistsreplacement/${academicYearId}/${disciplineId}/${admissionId}`,
      {
        params: {
          companyId,
          visitDate,
        },
      }
    );
  },
  async getVisitRegion(academicYearId, companyId) {
    return await api.get(`${apiUrl}/regions/${academicYearId}`, {
      params: {
        companyId,
      },
    });
  },
  async getVisitDistrict(academicYearId, regionId, companyId) {
    return await api.get(`${apiUrl}/districts/${academicYearId}/${regionId}`, {
      params: {
        companyId,
      },
    });
  },
  async getVisitSchool(academicYearId, regionId, districtId, companyId) {
    return await api.get(
      `${apiUrl}/schools/${academicYearId}/${regionId}/${districtId}`,
      {
        params: {
          companyId,
        },
      }
    );
  },
  async getVisitMunicipalities(academicYearId, locationTypeId, companyId) {
    return await api.get(
      `${apiUrl}/municipalities/${academicYearId}/${locationTypeId}`,
      {
        params: {
          companyId,
        },
      }
    );
  },
  async getVisitLocationServices(
    academicYearId,
    locationTypeId,
    municipalityId,
    companyId
  ) {
    return await api.get(
      `${apiUrl}/locationServices/${academicYearId}/${locationTypeId}/${municipalityId}`,
      {
        params: {
          companyId,
        },
      }
    );
  },
  async getVisitCenters(academicYearId, municipalityId, companyId) {
    return await api.get(
      `${apiUrl}/companycenters/${academicYearId}/${municipalityId}`,
      {
        params: {
          companyId,
        },
      }
    );
  },
  async getVisitsCertification(model) {
    return await api.get(`api/report/visits/certification`, { params: model });
  },
  async getVisitsCertificationCompensatory(model) {
    return await api.post(`api/report/visits/certificationcompensatory`, model);
  },
  getStudentPeiInfo(studentSieId) {
    return api.get(`${apiUrl}/studentpeiinfo/${studentSieId}`);
  },
  saveEducationVisit(data) {
    return api.post(`${apiUrl}/saveeducationvisit`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getEducationVisits(requestId, month) {
    return api.get(`${apiUrl}/educationvisits/`, {
      params: {
        requestId,
        month: month,
      },
    });
  },
  getSpecialistWithAssistanceService() {
    return api.get(`${apiUrl}/specialistswithassistanceservice/`);
  },

  async getEducationVisitTypes(
    requestTypeId = null,
    disciplineTypeId = null,
    academicYearId = null,
    visitDate = null,
    schoolTypeId = null
  ) {
    return await api.get(`${apiUrl}/educationvisittypes`, {
      params: {
        requestTypeId,
        disciplineTypeId,
        academicYearId,
        visitDate,
        schoolTypeId,
      },
    });
  },

  async getDayVisitsDuration(admissionId, visitDate) {
    return await api.get(`${apiUrl}/dayvisitsduration`, {
      params: {
        admissionId,
        visitDate,
      },
    });
  },
  getSpecialistBySpecialtyType(academicYearId, companyId, specialtyType) {
    return apiMipe.get(`/api/tapRequests/specialistbyspecialtytype`, {
      params: {
        academicYearId,
        companyId,
        specialtyType,
      },
    });
  },
  async deleteEducationVisit(id) {
    return await api.delete(`${apiUrl}/deleteeducationvisit/${id}`);
  },
  async updateRegistryVisit(payload) {
    return api.put(`${apiUrl}/updateregistryvisit`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  async updateRegistryVisitSchedule(payload) {
    return api.put(`${apiUrl}/updateregistryvisitschedule`, payload);
  },
  getAcademicYearsAndCompensatoryNumbers(studentSieId, disciplineTypeId) {
    return apiMipe.get(
      `/api/visitregistryeducational/academicyearsandcompensatorynumbers/${studentSieId}/${disciplineTypeId}`
    );
  },
};
